// Configurações da marca NexPOS.
//
// theme.light e theme.dark são os dois conjuntos completos de tokens
// consumidos por componentes via CSS custom properties (var(--token-*)).
// theme.primary/primaryDark/accent/gradient seguem expostos como shortcuts
// para callers legados — apontam para a paleta light por padrão.
//
// Valores reconciliados com a fonte de verdade SCSS (_brand-runtime.scss)
// na SUP-204 (P0.1+P0.2), seguindo SUP-202 §1.1/§1.2 e a aprovação CEO
// 585350c1 (opção a).
const lightTheme = {
  primary: '#2563EB',
  primaryDark: '#1D4ED8',
  primaryLight: '#0EA5E9',
  accent: '#0EA5E9',
  background: '#F8FAFC',
  surface: '#FFFFFF',
  surfaceAlt: '#F1F5F9',
  border: '#E2E8F0',
  divider: '#E2E8F0',
  text: {
    primary: '#0F172A',
    secondary: '#64748B',
    hint: '#94A3B8',
    onPrimary: '#FFFFFF',
    onSurface: '#0F172A'
  },
  // Status normalizados (decisão A — idênticos Concilia/NexPOS, paleta Vuexy).
  status: {
    success: '#28C76F',
    error: '#EA5455',
    warning: '#FF9F43',
    info: '#00CFE8'
  },
  // Soft tints — alinhados com _brand-runtime.scss (Vuexy).
  soft: {
    primary: '#E1ECFF',
    success: '#DDF6E8',
    error: '#FCE4E4',
    warning: '#FFF5EB',
    info: '#E0F8FB'
  },
  dataviz: ['#2563EB', '#0EA5E9', '#28C76F', '#FF9F43', '#00CFE8'],
  gradient: 'linear-gradient(118deg, #2563EB, #1D4ED8)'
}

const darkTheme = {
  primary: '#2563EB',
  primaryDark: '#1D4ED8',
  primaryLight: '#0EA5E9',
  accent: '#0EA5E9',
  background: '#161D31',
  surface: '#283046',
  surfaceAlt: '#161D31',
  border: '#3B4253',
  divider: '#3B4253',
  text: {
    primary: '#D0D2D6',
    secondary: '#B4B7BD',
    hint: '#676D7D',
    onPrimary: '#FFFFFF',
    onSurface: '#D0D2D6'
  },
  status: {
    success: '#28C76F',
    error: '#EA5455',
    warning: '#FF9F43',
    info: '#00CFE8'
  },
  // Soft tints no dark — alinhados com _brand-runtime.scss (Vuexy).
  soft: {
    primary: '#1E3A8A',
    success: '#1A3328',
    error: '#3A2126',
    warning: '#3A2A1F',
    info: '#1A2E3A'
  },
  dataviz: ['#2563EB', '#0EA5E9', '#28C76F', '#FF9F43', '#00CFE8'],
  gradient: 'linear-gradient(118deg, #2563EB, #1D4ED8)'
}

const nexpos = {
  key: 'nexpos',
  isNexPOS: true,
  isConciliaPOS: false,
  appName: 'NexPOS',
  displayName: 'NexPOS',
  layoutType: 'vertical',
  storagePrefix: 'nexpos',
  apiUrls: {
    dev: 'https://api-nexpos-stag.homolog.dev.br/',
    stag: 'https://api-nexpos-stag.suportepos.com.br/',
    hml: 'https://api-hml-nexpos.suportepos.com.br/',
    prod: 'https://api-nexpos.suportepos.com.br/'
  },
  corporateName: 'SuportePOS',
  corporateUrl: 'https://suportepos.com.br/',
  institutional: 'A NexPOS é um produto da SuportePOS.',
  invoiceFilenamePrefix: 'boleto_nexpos',
  excelFilenamePrefix: 'nexpos',
  pageTitleSuffix: 'NexPOS',
  invoiceReturnUrl: 'https://suportepos.com.br/',
  theme: {
    primary: lightTheme.primary,
    primaryDark: lightTheme.primaryDark,
    accent: lightTheme.accent,
    gradient: lightTheme.gradient,
    // Cor exibida na address bar do navegador (PWA theme_color e
    // <meta name="theme-color">). NexPOS usa o primaryDark (#1D4ED8) —
    // reconciliado com SCSS na SUP-204 conforme aprovação CEO 585350c1.
    metaThemeColor: lightTheme.primaryDark,
    light: lightTheme,
    dark: darkTheme
  },
  assets: {
    logo: require('@src/assets/images/logo/nexpos/logo.png'),
    logoDark: require('@src/assets/images/logo/nexpos/logo_dark.png'),
    logoMonoLight: require('@src/assets/images/logo/nexpos/logo_dark.png'),
    logoMonoDark: require('@src/assets/images/logo/nexpos/logo.png'),
    mark: require('@src/assets/images/logo/nexpos/ic_launcher_foreground.png'),
    powerby: require('@src/assets/images/logo/logosuportepos.svg').default
  }
}

export default nexpos
